

export const PROPERTY_TAB_GENERAL = 'GeneralConstruction';
export const PROPERTY_TAB_GENERAL_SITUATIONANDTYPE = 'generalSituationAndTypeOfProperty';
export const PROPERTY_TAB_ROOM = 'Room';
export const PROPERTY_TAB_ADMINISTARTION = 'Administration';
export const PROPERTY_TAB_PUBTEXT = 'DescriptionOrPubText';
export const PROPERTY_TAB_DESCRIPTIONS = 'DescriptionOrPubText';
export const PROPERTY_TAB_DOCUMENTS = 'Document';
export const PROPERTY_TAB_PICTURES = 'Picture';
export const PROPERTY_TAB_PUBLISH_PLAN = 'PublPlanning';
export const PROPERTY_TAB_EVOLUTION_PICTURES = 'EvolutionPicture';
export const PROPERTY_TAB_ENVIRONMENT_PICTURES = 'EnvironmentPicture';
export const PROPERTY_TAB_VIRTUAL_TOUR = 'VirtualTour';
export const PROPERTY_TAB_VIRTUAL_TOUR_VIDEO = 'Video';
export const PROPERTY_TAB_FEATURES = 'Feature';
export const PROPERTY_TAB_RELATION = 'Relation';
export const PROPERTY_TAB_FINANCE = 'Finance';
export const PROPERTY_TAB_ENVIRONMENT = 'Environment';
export const PROPERTY_TAB_ENVIRONMENTS = 'Environments';
export const PICTURES_OF_ENVIRONMENT = 'PicturesOfEnvironment';
export const PROPERTY_TAB_CONSTRUCTION = 'GeneralConstruction';
export const PROPERTY_TAB_COSTS = 'Cost';
export const OBJECT_TYPE = {
    "PROPERTY": "0",
    "PROJECT": "1",
    "UNITS": "2",
    "ANNEX": "3",
};

export enum SIGN_DOCUMENT_STATUS {
    IS_NOT_DETECTED = 0,
    VALID = 1,
    COMPLETED = 2,
    EXPIRED = 3,
    CANCELLED = 4
}

/** Rejections from POST /eideasy-sign-document/expiry (Omnicasa.Dto ExceptionCodes.EidEasySign). */
export enum EID_EASY_EXPIRY_ERROR {
    REQUEST_NOT_FOUND = 38300,
    REQUEST_NOT_EXTENDABLE = 38301,
    REQUEST_ALREADY_EXPIRED = 38302,
    EXPIRY_NOT_LATER = 38303
}

export enum SIGNER_STATUS {
    IS_NOT_DETECTED = 0,
    IN_PROCESS = 2,
    COMPLETED = 3,
    EXPIRED = 5,
    CANCELLED = 6,
}

export enum TYPE_SIGN_VALUE {
    EMAIL = 'Email',
    LIVE = 'Live'
}
export const TYPE_SIGN: Array<{label: string, value: string, hint?: string}> = [
    {label: 'EMAIL', value: TYPE_SIGN_VALUE.EMAIL, hint: 'SEND_AN_EMAIL_FOR_THE_USER_TO_SIGN'},
    {label: 'LIVE', value: TYPE_SIGN_VALUE.LIVE, hint: 'THE_USER_CAN_SIGN_IN_PERSON_AT_THE_OFFICE'},
]

/** SWA-7537: how a signature request invites its signers (EidEasySignatureRequests.SigningMode). */
export const EID_SIGNING_MODE = { SEQUENTIAL: 1, PARALLEL: 2 } as const;
/** Send drawer "Signing order" choices, parallel first (the default). */
export const EID_SIGNING_MODE_OPTIONS: Array<{label: string, value: number, hint: string, icon: string}> = [
    {label: 'EID_SIGNING_MODE_PARALLEL', value: EID_SIGNING_MODE.PARALLEL, hint: 'EID_SIGNING_MODE_PARALLEL_HINT', icon: 'ico_person'},
    {label: 'EID_SIGNING_MODE_SEQUENTIAL', value: EID_SIGNING_MODE.SEQUENTIAL, hint: 'EID_SIGNING_MODE_SEQUENTIAL_HINT', icon: 'el-icon-sort'},
];

export const PROJECT_TAB_BUILDING = "ProjectBuildings";

export const RELATION_COMMENT_MAX_LENGTH = 255;

// Immoweb API description limit (WinApp config key ImmoWebApiMaxCharsFlashText)
export const IMMOWEB_API_MAX_CHARS_FLASH_TEXT = 2500;

// Immoweb API extra-information limit (WinApp config key ImmoWebApiMaxCharsMoreInfo)
export const IMMOWEB_API_MAX_CHARS_MORE_INFO = 250;

export const RELATION_MAP = {
    actualtenant: "actual tenant",
    newtenant: "new tenant",
    buyer: "buyer",
    proprietors: "proprietors",
    bodycorporate: "body corporate",
    "notary/seller": "notary/seller",
    "notary/buyer": "notary/buyer",
    manager: "manager",
    family: "family",
    "co-agent": "co-agent",
    various: "various",
    leavingtenant: "leaving tenant",

};